const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/api/v1";

export const RefundQuery: any = {
    getRefund: Backofficebff + '/v1/refund/getRefund',
    getRefundListHistory: Backofficebff + '/v1/refund/getRefundListHistory',
    doRefund: Backofficebff + '/v1/refund/doRefund',
    getrefundofreturn: Backofficebff + '/v1/refund/GetRefundOfReturn',
    getDocumentHeaderOfSellerReturnDispatchList:
        Backofficebff + '/v1/refund/getDocumentHeaderOfSellerReturnDispatchList',
    convertRefundToWalletTransaction: Backofficebff + '/v1/refund/convertrefundtowallettransaction',
    searchRefund: Backofficebff + '/v1/refund/searchRefund',
    createPetition: Backofficebff + '/v1/refund/createPetition',
    tryDoRefund: Backofficebff + '/v1/refund/trydoRefund',
    updateWireRefundCustomerChoice: Backofficebff + '/v1/refund/UpdateWireRefundCustomerChoice',
    GetRefundList: Backofficebff + '/v1/refund/get-refund-list',
    GetRefundStatusList: Backofficebff + '/v1/refundrest/get-refund-status-list',
    getreturntosellerlistshippinglistsforstorev2:
        Backofficebff + '/v1/refund/getreturntosellerlistshippinglistsforstore-v2',
    getRefundImages: Backofficebff + '/v1/return/get-base64-from-photo-url',
};
